/* =========================================================
   Lumière Jewelry Theme — Scroll animations & polish
   ========================================================= */
(function () {
  'use strict';

  /* ---------- Reveal-on-scroll ---------- */
  var animatedEls = document.querySelectorAll('[data-animate]');
  if ('IntersectionObserver' in window && animatedEls.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    animatedEls.forEach(function (el) { observer.observe(el); });
  } else {
    animatedEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Auto-stagger children inside [data-animate-group] ---------- */
  document.querySelectorAll('[data-animate-group]').forEach(function (group) {
    var children = group.querySelectorAll('[data-animate]');
    children.forEach(function (child, i) {
      child.setAttribute('data-animate-delay', String(Math.min(i, 4)));
    });
  });

  /* ---------- Product grid horizontal scroll drag (desktop mouse) ---------- */
  document.querySelectorAll('.product-grid--scroll').forEach(function (track) {
    var isDown = false, startX, scrollLeft;
    track.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    ['mouseleave', 'mouseup'].forEach(function (evt) {
      track.addEventListener(evt, function () { isDown = false; });
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX) * 1.2;
    });
  });

  /* ---------- Section title count-up (optional stat highlight) ---------- */
  document.querySelectorAll('[data-count-up]').forEach(function (el) {
    var target = parseFloat(el.dataset.countUp);
    if (isNaN(target)) return;
    var duration = 900;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      el.textContent = Math.floor(progress * target);
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = target;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          requestAnimationFrame(step);
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.5 });
    obs.observe(el);
  });
})();
